import { render, staticRenderFns } from "./NavDrawer.vue?vue&type=template&id=5c038532&scoped=true"
import script from "./NavDrawer.vue?vue&type=script&lang=js"
export * from "./NavDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c038532",
  null
  
)

export default component.exports